// extracted by mini-css-extract-plugin
export default {"lists__container":"Main_lists__container__-cn+g","main":"Main_main__OVpPo"};